var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacturation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 16 16",
    id: "Cashless-Payment-Online-Statement-Monitor--Streamline-Ultimate",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Cashless Payment Online Statement Monitor Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.433125 7.7143125c0.1479375 0.194375 0.34056250000000005 0.3501875 0.5615625 0.4541875 0.22093749999999998 0.104 0.46375 0.1531875 0.7078125000000001 0.1433125 0.7775 0 1.40875 -0.473125 1.40875 -1.056875s-0.63125 -1.0562375 -1.40875 -1.0562375 -1.4093749999999998 -0.47375 -1.4093749999999998 -1.0574999999999999c0 -0.58375 0.63125 -1.056875 1.4093749999999998 -1.056875 0.24406250000000002 -0.009812499999999998 0.486875 0.039375 0.7078125000000001 0.14339375 0.22100000000000003 0.10401250000000001 0.413625 0.2597875 0.5615625 0.45410625000000004",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.702499999999999 8.311937499999999v0.704375",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.702499999999999 3.379975v0.704375",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.72125 1.40625H2.27875C1.36540625 1.40625 0.625 2.14665625 0.625 3.06v6.6925c0 0.9133125 0.7404062499999999 1.65375 1.65375 1.65375h10.442499999999999c0.9133125 0 1.65375 -0.7404375000000001 1.65375 -1.65375V3.06c0 -0.9133437499999999 -0.7404375000000001 -1.65375 -1.65375 -1.65375Z",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 11.40625v2.1875",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.375 13.59375h6.25",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.88871875 4.1806h3.7574687499999997",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.88871875 6.5718125h3.7574687499999997",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.88871875 8.9631875h1.87875",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacturation);
export default __webpack_public_path__ + "static/media/icon-facturation.9220292aa49fdef29b36a3f0ad8163b5.svg";
export { ForwardRef as ReactComponent };